import React from 'react'
import { connect } from 'dva'
import PropTypes from 'prop-types'
import { getFeatureDisplayString } from '../../../lib/features'
import ContentOwnership from '../ContentOwnership'
import FeatureDetailActions from './FeatureDetailActions'
import FeatureDetailCollections from './FeatureDetailCollections'
import FeatureDetailHeader from './FeatureDetailHeader'
import FeatureDetailNotes from './FeatureDetailNotes'
import FeatureDetailPhotos from './FeatureDetailPhotos'
import FeatureDetailSharing from './FeatureDetailSharing'
import FeatureEditor from './FeatureEditor'
import FeatureStatistics from './FeatureStatistics'
import Loader from '../../Loader'
import SidebarDetailHeader from '../SidebarDetailHeader'
import styles from './FeatureDetail.module.scss'

function FeatureDetailSidebar(props) {
  return (
    <>
      {props.selectedFeatureLoading ? (
        <div className={styles.loader}>
          <Loader active={true} />{props.loadingText}
        </div>
      ) : (
        <>
          <SidebarDetailHeader />
          <FeatureDetailHeader />
          <FeatureDetailActions />
          <FeatureDetailSharing />
          {!props.selectedFeature.isOwner ? <ContentOwnership sharedBy={props.selectedFeature.sharedBy} type={props.selectedFeature.properties.ghType} /> : null}
          <FeatureStatistics feature={props.selectedFeature} hideCoords={props.hideCoords} />
          <FeatureDetailNotes />
          {props.selectedFeature.photoIds && props.selectedFeature.photoIds.length ? <FeatureDetailPhotos /> : null}
          {props.selectedFeature.collectionIds && props.selectedFeature.collectionIds.length ? <FeatureDetailCollections /> : null}
        </>
      )}
    </>
  )
}

FeatureDetailSidebar.propTypes = {
  featureErrorId: PropTypes.string,
  hasFeatureErrored: PropTypes.bool,
  hideCoords: PropTypes.bool,
  isEditingFeature: PropTypes.bool,
  isUpdatingLocation: PropTypes.bool,
  loadingText: PropTypes.string,
  selectedFeature: PropTypes.object,
  selectedFeatureLoading: PropTypes.bool,
}

export default connect((model) => {
  const { hideCoords} = model.app
  const { featureErrorId, hasFeatureErrored, isEditingFeature, selectedFeature, selectedFeatureLoading } = model.features
  const { isUpdatingLocation } = model.map
  let loadingText = 'Loading content...'
  if (selectedFeature) {
    const { properties } = selectedFeature
    if (properties && properties.ghType) {
      loadingText = `Loading ${getFeatureDisplayString(properties.ghType)}...`
    }
  }
  return {
    featureErrorId,
    hasFeatureErrored,
    hideCoords,
    isEditingFeature,
    isUpdatingLocation,
    loadingText,
    selectedFeature,
    selectedFeatureLoading
  }
})(FeatureDetailSidebar)
